import React from 'react';
import styled from '@emotion/styled';

interface Props {
  isLoading: boolean;
  loader: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * This component preserves the size of the reloading component.
 * While new data is loading, the previous content is rendered (hidden) to maintain the parent component's size.
 * This prevents layout shifts, such as content "jumping" when real content is temporarily replaced by a skeleton loader.
 */

const SizePreservingLoader: React.FC<Props> = ({ isLoading, loader, children }) => {
  return (
    <ZStack>
      <Content hidden={isLoading}>{children}</Content>
      {isLoading ? loader : null}
    </ZStack>
  );
};

export default SizePreservingLoader;

const Content = styled('div', { shouldForwardProp: (prop) => !['hidden'].includes(prop) })`
  ${({ hidden }) => (hidden ? 'visibility: hidden;' : '')}
`;

const ZStack = styled.div`
  display: grid;

  & > * {
    grid-row: 1;
    grid-column: 1;
  }
`;
